import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { setAccountAdminQueryData } from './useAdminAccountQuery';

export function useUpdateWebsiteBuildMutation({
	accountId,
	onError,
}: {
	accountId: string;
	onError: (err: Api.IOperationResultNoValue) => void;
}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (update: Api.IWebsiteBuildUpdate) =>
			userSession.webServiceHelper.callAsync<Api.IAccount>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext: { account: { id: accountId } },
					urlPath: 'account/features/websites/build',
				}),
				'PUT',
				update
			),
		onError,
		onSuccess: setAccountAdminQueryData,
	});
}
